(() => {
  const configElement = document.getElementById('mc-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  const header = document.querySelector('[data-mc-header]');
  let lastFocused = null;
  let restoringFocus = false;
  let searchController = null;
  let searchTimer;
  let cartQueue = Promise.resolve();
  let filterDataPromise;
  const filterForm = document.querySelector('[data-mc-collection-filter]');
  const errorText = config.error;
  const show = (id) => {
    const dialog = document.getElementById(id);
    if (!dialog || dialog.open) return;
    lastFocused = document.activeElement;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    if (id === 'mc-cart') refreshCart().catch(() => status(dialog, errorText));
    if (id === 'mc-filters' && filterForm) loadFilterData().catch(() => status(filterForm, errorText));
    if (id === 'mc-search') {
      const input = dialog.querySelector('[data-mc-search]');
      const headerInput = document.querySelector('[data-mc-search-open]');
      if (headerInput.value) input.value = headerInput.value;
      loadSearch(input.value);
      input.focus();
    }
  };
  const close = (dialog) => {
    restoringFocus = true;
    dialog.close();
    document.documentElement.style.overflow = '';
    lastFocused?.focus();
    queueMicrotask(() => {restoringFocus = false;});
  };
  const status = (parent, text) => {
    let output = parent.querySelector('[data-mc-buy-status]');
    if (!output) {
      output = document.createElement('p');
      output.dataset.mcBuyStatus = '';
      output.setAttribute('role', 'status');
      parent.append(output);
    }
    output.textContent = text;
  };
  const request = async (url, options = {}) => {
    const response = await fetch(url, {credentials: 'same-origin', ...options});
    if (!response.ok) {
      let message = errorText;
      try {const data = await response.json(); message = data.description || data.message || message;} catch {}
      throw new Error(message);
    }
    return response;
  };
  const refreshCart = async () => {
    const response = await request(root + '?sections=mc-cart-content');
    const sections = await response.json();
    if (!sections['mc-cart-content']) throw new Error(errorText);
    document.querySelectorAll('[data-mc-cart-content]').forEach(target => {target.innerHTML = sections['mc-cart-content'];});
    const cartResponse = await request(root + 'cart.js');
    const cart = await cartResponse.json();
    document.querySelectorAll('[data-mc-cart-count]').forEach(target => {target.textContent = cart.item_count; target.hidden = cart.item_count === 0;});
    return cart;
  };
  const changeCart = (body) => {
    const pending = cartQueue.then(async () => {
      await request(root + 'cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body)});
      await refreshCart();
    });
    cartQueue = pending.catch(() => {});
    return pending;
  };
  const colorTable = [['siyah','Black','#171717'],['ekru','Ecru','#ede8da'],['beyaz','White','#fff'],['kahve','Brown','#705443'],['bej','Beige','#cbb9a1'],['lacivert','Navy','#182a44'],['mavi','Blue','#427ab0'],['yeşil','Green','#54764c'],['kırmızı','Red','#b72d35'],['bordo','Burgundy','#71353d'],['gri','Grey','#8a8a8a'],['pembe','Pink','#dfa4b5'],['mor','Purple','#7d628b'],['turuncu','Orange','#d17b3a'],['sarı','Yellow','#d7b948']];
  function dimensions(item) {
    const names = item.options.map(option => String(typeof option === 'string' ? option : option.name).toLocaleLowerCase('tr'));
    const sizeIndex = names.findIndex(name => /beden|size/.test(name));
    const colorIndex = names.findIndex(name => /renk|colou?r/.test(name));
    const available = item.variants.filter(variant => variant.available);
    const sizes = sizeIndex < 0 ? [] : [...new Set(available.map(variant => variant.options[sizeIndex]))];
    const title = item.title.toLocaleLowerCase('tr');
    const colors = colorIndex < 0 ? colorTable.filter(color => title.includes(color[0])).map(color => color[0]) : [...new Set(available.map(variant => String(variant.options[colorIndex]).trim().toLocaleLowerCase('tr')))];
    return {sizes,colors,available:available.length > 0};
  }
  function filterPill(name,value,count,swatch) {
    const label=document.createElement('label');label.className='mc-filter-pill';
    const input=document.createElement('input');input.type='checkbox';input.name=name;input.value=value;
    input.checked=new URL(location.href).searchParams.getAll(name).map(selected=>name==='mc_color'?selected.toLocaleLowerCase('tr'):selected).includes(value);
    const span=document.createElement('span');
    if(swatch){const dot=document.createElement('i');dot.style.background=swatch;span.append(dot);}
    else{const mark=document.createElement('b');mark.setAttribute('aria-hidden','true');mark.textContent='◇';span.append(mark);}
    const color=colorTable.find(color=>color[0]===value.toLocaleLowerCase('tr'));
    const labelText=swatch?value.charAt(0).toLocaleUpperCase('tr')+value.slice(1):value;
    span.append(document.createTextNode(config.locale==='en'&&color?color[1]:labelText));
    const small=document.createElement('small');small.textContent='('+count+')';span.append(small);
    label.append(input,span);return label;
  }
  async function loadFilterData() {
    if(!filterDataPromise)filterDataPromise=(async()=>{
      const items=[],cards=new Map();
      let url=new URL(filterForm.action);url.searchParams.set('section_id','mc-filter-data');
      const sort=new URL(location.href).searchParams.get('sort_by');if(sort)url.searchParams.set('sort_by',sort);
      for(let pageNumber=0;url&&pageNumber<20;pageNumber++){
        const response=await request(url);
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const data=doc.querySelector('[data-mc-filter-products]');if(!data)throw new Error(errorText);
        const batch=JSON.parse(data.textContent);
        items.push(...batch.map(item=>({...item,...dimensions(item)})));
        const nodes=doc.querySelectorAll('[data-mc-filter-cards] .mc-card');nodes.forEach((card,index)=>cards.set(String(batch[index].id),card));
        const next=doc.querySelector('[data-mc-filter-data]').dataset.next;
        url=next?new URL(next,location.origin):null;if(url)url.searchParams.set('section_id','mc-filter-data');
      }
      for(const [property,name,targetSelector] of [['sizes','mc_size','[data-mc-size-filters]'],['colors','mc_color','[data-mc-color-filters]']]){
        const counts=new Map();items.forEach(item=>{if(item.available)item[property].forEach(value=>counts.set(value,(counts.get(value)||0)+1));});
        const target=filterForm.querySelector(targetSelector);target.replaceChildren();
        [...counts].sort(([a],[b])=>a.localeCompare(b,config.locale,{numeric:true})).forEach(([value,count])=>{const color=colorTable.find(color=>color[0]===value.toLocaleLowerCase('tr'));target.append(filterPill(name,value,count,property==='colors'?(color?.[2]||'#ddd'):null));});
      }
      const params=new URL(location.href).searchParams;
      filterForm.querySelector('[data-mc-min]').value=params.get('filter.v.price.gte')||'';
      filterForm.querySelector('[data-mc-max]').value=params.get('filter.v.price.lte')||'';
      ['filter.v.availability','mc_new','mc_sale'].forEach(name=>{filterForm.querySelector('[name="'+name+'"]').checked=params.get(name)==='1';});
      return {items,cards};
    })().catch(error=>{filterDataPromise=null;throw error;});
    return filterDataPromise;
  }
  async function applyCollectionFilter(updateURL=true) {
    const {items,cards}=await loadFilterData();
    const params=updateURL?new URLSearchParams(new FormData(filterForm)):new URL(location.href).searchParams;
    const sizes=params.getAll('mc_size'),colors=params.getAll('mc_color').map(value=>value.toLocaleLowerCase('tr'));
    const lower=params.get('filter.v.price.gte'),upper=params.get('filter.v.price.lte');
    const newThreshold=Math.floor(Date.now()/1000)-30*86400;
    const selected=items.filter(item=>(!sizes.length||sizes.some(value=>item.sizes.includes(value)))&&(!colors.length||colors.some(value=>item.colors.includes(value)))&&(params.get('filter.v.availability')!=='1'||item.available)&&(params.get('mc_sale')!=='1'||item.compareAt>item.price)&&(params.get('mc_new')!=='1'||Number(item.createdAt)>=newThreshold)&&(!lower||item.price>=Number(lower)*100)&&(!upper||item.price<=Number(upper)*100));
    const grid=document.querySelector('[data-mc-filter-grid]');grid.replaceChildren(...selected.map(item=>cards.get(String(item.id)).cloneNode(true)));
    if(!selected.length){const message=document.createElement('p');message.textContent=document.querySelector('[data-mc-filter-empty]')?.textContent|| (config.locale==='en'?'No products found.':'Ürün bulunamadı.');grid.append(message);}
    initializeGalleries(grid);
    document.querySelectorAll('.mc-pagination').forEach(node=>node.hidden=true);
    const count=document.querySelector('.mc-result-count');if(count)count.textContent=selected.length+' '+(config.locale==='en'?'products':'ürün');
    if(updateURL){for(const [key,value] of [...params])if(!value)params.delete(key);const url=new URL(filterForm.action);url.search=params.toString();history.pushState({},'',url);}
    const sortForm=document.querySelector('.mc-sort-form');
    sortForm.querySelectorAll('input[type=hidden]').forEach(input=>input.remove());
    for(const [name,value] of params){if(name==='sort_by'||!value)continue;const input=document.createElement('input');input.type='hidden';input.name=name;input.value=value;sortForm.append(input);}
    const dialog=document.getElementById('mc-filters');if(dialog.open)close(dialog);
    return selected.length;
  }
  async function loadSearch(term) {
    searchController?.abort();
    searchController = new AbortController();
    const results = document.querySelector('[data-mc-search-results]');
    const signal = searchController.signal;
    let url;
    if (term.trim()) {
      url = root + 'search/suggest?q=' + encodeURIComponent(term.trim()) + '&resources[type]=product&resources[limit]=6&section_id=mc-search-results';
    } else {
      url = root + '?section_id=mc-search-results';
    }
    try {
      const response = await request(url, {signal});
      if (!signal.aborted) {results.innerHTML = await response.text(); initializeGalleries(results);}
    } catch (error) {if (error.name !== 'AbortError') results.textContent = errorText;}
  }
  const initializeGalleries = (scope = document) => {
    scope.querySelectorAll('[data-mc-gallery]').forEach(gallery => {
      if (gallery.dataset.mcReady) return;
      gallery.dataset.mcReady = 'true';
      const dots = gallery.parentElement.querySelector('[data-mc-dots]');
      if (!dots) return;
      const update = () => {
        const first = gallery.firstElementChild;
        if (!first) return;
        const width = first.getBoundingClientRect().width;
        const gap = parseFloat(getComputedStyle(gallery).gap) || 0;
        const index = Math.round(gallery.scrollLeft / (width + gap));
        dots.querySelectorAll('[data-mc-dot]').forEach(dot => {dot.setAttribute('aria-current', String(Number(dot.dataset.mcDot) === index));});
      };
      gallery.addEventListener('scroll', update, {passive: true});
      dots.addEventListener('click', event => {
        const dot = event.target.closest('[data-mc-dot]');
        if (!dot) return;
        const child = gallery.children[Number(dot.dataset.mcDot)];
        if (child) gallery.scrollTo({left: child.offsetLeft - gallery.firstElementChild.offsetLeft, behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
      });
      update();
    });
  };
  const money = cents => new Intl.NumberFormat(config.locale, {style: 'currency', currency: config.currency}).format(cents / 100);
  const quickAdd = async (url) => {
    show('mc-quick');
    const target = document.querySelector('[data-mc-quick-content]');
    target.replaceChildren();
    const response = await request(url + '.js');
    const product = await response.json();
    const title = document.createElement('p'); title.className = 'mc-quick-content-title'; title.textContent = product.title;
    const form = document.createElement('form'); form.dataset.mcBuy = ''; form.method = 'post'; form.action = root + 'cart/add';
    const fieldset = document.createElement('fieldset'); fieldset.className = 'mc-variants';
    product.variants.forEach(variant => {
      const label = document.createElement('label');
      const radio = document.createElement('input'); radio.type = 'radio'; radio.name = 'id'; radio.value = variant.id; radio.disabled = !variant.available;
      const text = document.createElement('span'); text.textContent = variant.title;
      label.append(radio, text); fieldset.append(label);
    });
    const price = document.createElement('p'); price.textContent = money(product.price);
    form.addEventListener('change', () => {const variant = product.variants.find(v => String(v.id) === new FormData(form).get('id')); if (variant) price.textContent = money(variant.price);});
    const button = document.createElement('button'); button.type = 'submit'; button.className = 'mc-add'; button.textContent = config.texts; button.disabled = !product.available;
    form.append(fieldset, price, button); target.append(title, form);
  };
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-mc-open]');
    if (opener) {show(opener.dataset.mcOpen); return;}
    const closer = event.target.closest('[data-mc-close]');
    if (closer) {close(closer.closest('dialog')); return;}
    const quick = event.target.closest('[data-mc-quick]');
    if (quick) {event.preventDefault(); quickAdd(quick.dataset.mcQuick).catch(() => status(document.querySelector('[data-mc-quick-content]'), errorText)); return;}
    const remove = event.target.closest('[data-mc-remove]');
    if (remove) {remove.disabled = true; changeCart({id: remove.dataset.mcRemove, quantity: 0}).catch(error => status(remove.closest('.mc-cart-content'), error.message)); return;}
    const favorite = event.target.closest('[data-mc-favorite]');
    if (favorite) {
      const next = favorite.getAttribute('aria-pressed') !== 'true';
      favorite.setAttribute('aria-pressed', String(next));
      try {localStorage.setItem('mc-favourite-' + favorite.dataset.mcFavorite, String(next));} catch {}
    }
    const guide = event.target.closest('[data-mc-size-guide]');
    if (guide) document.getElementById('mc-size-guide').open = true;
    if (event.target.closest('[data-mc-cookie]')) window.privacyBanner?.showPreferences?.();
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-mc-sort]')) event.target.form.requestSubmit();
    if (event.target.matches('[data-mc-quantity]')) {
      const input = event.target;
      const value = Math.min(99, Math.max(0, Math.floor(Number(input.value) || 0)));
      input.disabled = true;
      changeCart({id: input.dataset.mcQuantity, quantity: value}).catch(error => status(input.closest('.mc-cart-content'), error.message));
    }
    if (event.target.matches('[data-mc-price]')) {
      const radio = event.target;
      document.querySelector('[data-mc-product-price]').textContent = radio.dataset.mcPrice;
      const compare = document.querySelector('[data-mc-product-compare]');
      compare.textContent = radio.dataset.mcCompare; compare.hidden = radio.dataset.mcSale !== 'true';
      const media = document.querySelector('[data-mc-media="' + radio.dataset.mcVariantMedia + '"]');
      if (media) {const gallery = media.parentElement; gallery.scrollTo({left: media.offsetLeft - gallery.firstElementChild.offsetLeft, behavior: 'smooth'});}
      const url = new URL(location.href); url.searchParams.set('variant', radio.value); history.replaceState({}, '', url);
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('[data-mc-buy]')) return;
    event.preventDefault();
    const data = new FormData(form);
    if (!data.get('id')) {status(form, document.querySelector('#mc-quick h2')?.textContent || errorText); return;}
    const button = form.querySelector('[type=submit]'); button.disabled = true;
    try {
      await request(root + 'cart/add.js', {method: 'POST', body: data});
      status(form, config.added);
      await refreshCart();
      const quick = form.closest('#mc-quick'); if (quick) close(quick);
      show('mc-cart');
    } catch (error) {status(form, error.message);} finally {button.disabled = false;}
  });
  document.querySelectorAll('dialog[id^=mc-]').forEach(dialog => {
    dialog.addEventListener('cancel', () => {document.documentElement.style.overflow = ''; restoringFocus = true; lastFocused?.focus(); queueMicrotask(() => {restoringFocus = false;});});
    dialog.addEventListener('click', event => {if (event.target === dialog) {const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(dialog);}});
  });
  document.querySelector('[data-mc-search-open]').addEventListener('focus', () => {if (!restoringFocus) show('mc-search');});
  document.querySelector('[data-mc-search]').addEventListener('input', event => {clearTimeout(searchTimer); searchTimer = setTimeout(() => loadSearch(event.target.value), 250);});
  const trendsInput = document.querySelector('[data-mc-trends]');
  const trends = trendsInput.dataset.mcTrends.split('|').map(term => term.trim()).filter(Boolean);
  let trendIndex = 0;
  if (trends.length) {
    trendsInput.placeholder = trends[0];
    setInterval(() => {if (document.hidden || trendsInput.value || document.getElementById('mc-search').open) return; trendIndex = (trendIndex + 1) % trends.length; trendsInput.placeholder = trends[trendIndex];}, 3500);
  }
  let ticking = false;
  const updateHeader = () => {
    ticking = false;
    header.classList.toggle('mc-scrolled', scrollY > 12);
    const points = [header.getBoundingClientRect().top + 20, header.getBoundingClientRect().bottom - 16];
    let overPhoto = false;
    for (const y of points) {
      const elements = document.elementsFromPoint(innerWidth / 2, Math.max(0, y));
      if (elements.some(element => element.closest('.mc-hero,.mc-category-banner,.mc-card-media,.mc-product-media,.mc-editorial>a'))) overPhoto = true;
    }
    header.classList.toggle('mc-on-light', !overPhoto);
    header.classList.toggle('mc-over-photo', overPhoto);
  };
  addEventListener('scroll', () => {if (!ticking) {ticking = true; requestAnimationFrame(updateHeader);}}, {passive: true});
  addEventListener('resize', updateHeader);
  updateHeader(); initializeGalleries();
  if(filterForm){
    filterForm.addEventListener('submit',event=>{event.preventDefault();const button=filterForm.querySelector('[type=submit]');button.disabled=true;applyCollectionFilter().catch(error=>status(filterForm,error.message)).finally(()=>button.disabled=false);});
    const params=new URL(location.href).searchParams;
    if(['mc_size','mc_color','mc_new','mc_sale'].some(key=>params.has(key)))applyCollectionFilter(false).catch(()=>{});
    const sortForm=document.querySelector('.mc-sort-form');
    ['mc_size','mc_color','mc_new','mc_sale'].forEach(name=>params.getAll(name).forEach(value=>{const input=document.createElement('input');input.type='hidden';input.name=name;input.value=value;sortForm.append(input);}));
    addEventListener('popstate',()=>location.reload());
  }
  document.querySelectorAll('[data-mc-favorite]').forEach(button => {try {button.setAttribute('aria-pressed', String(localStorage.getItem('mc-favourite-' + button.dataset.mcFavorite) === 'true'));} catch {}});
  const observer = new IntersectionObserver(entries => {
    entries.forEach(async entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      const target = entry.target;
      try {
        const url = new URL(config.recommendations, location.origin);
        url.searchParams.set('product_id', target.dataset.mcRecommendations); url.searchParams.set('section_id', target.dataset.mcSection); url.searchParams.set('limit', '8'); url.searchParams.set('intent', target.dataset.mcIntent);
        const response = await request(url);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = html.querySelector('[data-mc-recommendations]');
        if (replacement?.querySelector('.mc-card')) {target.innerHTML = replacement.innerHTML; initializeGalleries(target);} else {target.hidden = true;}
      } catch {target.hidden = true;}
    });
  }, {rootMargin: '300px'});
  document.querySelectorAll('[data-mc-recommendations]').forEach(element => observer.observe(element));
  if (window.mcExistingGA4) {
    const startAnalytics = () => {
      const privacy = window.Shopify?.customerPrivacy;
      if (!privacy) return;
      const granted = privacy.currentVisitorConsent?.().analytics === 'yes' && privacy.analyticsProcessingAllowed();
      window['ga-disable-' + window.mcExistingGA4] = !granted;
      if (!granted || document.getElementById('mc-ga4')) return;
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () {window.dataLayer.push(arguments);};
      window.gtag('js', new Date());
      window.gtag('config', window.mcExistingGA4, {send_page_view: true});
      const script = document.createElement('script'); script.id = 'mc-ga4'; script.async = true; script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(window.mcExistingGA4); document.head.append(script);
    };
    document.addEventListener('visitorConsentCollected', startAnalytics);
    if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {if (!error) startAnalytics();});
  }
  document.addEventListener('shopify:section:load', event => initializeGalleries(event.target));
  const codesElement=document.getElementById('mc-collection-codes');
  if(codesElement){const codes=JSON.parse(codesElement.textContent);document.addEventListener('submit',event=>{const input=event.target.querySelector('input[name=q]');if(!input)return;const code=input.value.trim().toUpperCase().replace(/\s+/g,'');if(codes[code]){event.preventDefault();event.stopImmediatePropagation();location.assign(codes[code]);}},true);}
  document.querySelectorAll('.mc-menu-categories,.mc-product-rail,.mc-gallery').forEach(rail=>{
    let startX=0,startScroll=0,dragging=false,moved=false;
    rail.addEventListener('pointerdown',event=>{if(event.pointerType!=='mouse'||event.button!==0||event.target.closest('button,input')||event.target.closest('.mc-menu-categories,.mc-product-rail,.mc-gallery')!==rail)return;startX=event.clientX;startScroll=rail.scrollLeft;dragging=true;moved=false;});
    rail.addEventListener('pointermove',event=>{if(!dragging)return;const delta=event.clientX-startX;if(Math.abs(delta)>7){moved=true;rail.scrollLeft=startScroll-delta;event.preventDefault();}});
    addEventListener('pointerup',()=>{dragging=false;});
    rail.addEventListener('click',event=>{if(moved){event.preventDefault();event.stopPropagation();moved=false;}},true);
  });
})();
